
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressMortgagesFR]",
      function () {
        return require("private-next-pages/[...wordpressMortgagesFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressMortgagesFR]"])
      });
    }
  